import { axios } from '@Root/API'

export const edit = payload => {
	return axios.put(`student-engagement/${payload.id}`, payload)
}
